import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useFetch, usePromise } from '../hooks';
import { AcceptUIButton } from './authorize-net';
import { StripeCardForm } from './stripe';
/** Collects a card through whichever processor PAYMENT_PROVIDER selects and
 *  hands back a token the server can save. Callers stay provider-agnostic. */
export const PaymentMethodCollector = (props) => {
    const [configP] = useFetch(props.fetchConfig);
    const config = usePromise(configP);
    return _jsx(_Fragment, { children: !config ? _jsx(_Fragment, {}) : ({
            'authorize.net': _jsx(AcceptUIButton, { config: config, onLoadError: props.onLoadError, onFailure: props.onFailure, onToken: props.onToken, className: props.className, disabled: props.disabled, children: props.children }),
            'stripe': _jsx(StripeCardForm, { config: config, onLoadError: props.onLoadError, onFailure: props.onFailure, onToken: props.onToken, className: props.className, disabled: props.disabled, children: props.children }),
        })[config.provider] });
};
